<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DropZone from "@/components/widgets/dropZone";
import { ref } from "vue";

/**
 * Blog-detail component
 */
export default {
  page: {
    title: "Formulario Inbound",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DropZone, Layout, PageHeader },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
    };
    return { dropzoneFile, drop, selectedFile };
  },
  data() {
    return {
      title: "Formulario Inbound",
      items: [
        {
          text: "Administrativo",
          href: "/",
        },
        {
          text: "Formulario Inbound",
          active: true,
        },
      ],
      selectedRadioDefault: null,
      selectedRadioOutros: null,
      CheckboxOutrosHubs: null,
      CheckboxOutrasApis: null,
      CheckboxOutrosIntegracoes: null,
      imageSrc: require("@/assets/images/small/img-2.jpg"), // Usando require para importar a imagem
      windowWidth: 1040,
      windowHeight: 200,
    };
  },
  computed: {
    windowStyle() {
      return {
        width: `${this.windowWidth}px`,
        height: `${this.windowHeight}px`,
        overflow: "hidden",
        position: "relative", // Para posicionar a imagem interna
      };
    },
    imageStyle() {
      return {
        backgroundImage: `url(${this.imageSrc})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
      };
    },
  },
};
</script>
<style scoped>
.image-window {
  width: "100px";
  border: 1px solid #ccc;
  /* Adicione uma borda se desejar */
}

.image-content {
  background-repeat: "no-repeat";
  background-position: "center";
  position: "absolute";
  top: "0";
  left: "0";
  width: "100%";
  height: "100%";
}

.required {
  color: red;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div>
                    <div class="text-center">
                      <div class="mb-4">
                        <div class="image-window" :style="windowStyle">
                          <div class="image-content" :style="imageStyle"></div>
                        </div>
                        <hr />
                        <a href="#" class="badge bg-light font-size-12">
                          <i class="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                          Project
                        </a>
                      </div>
                      <h4>Questionário Operacional/Kick Off</h4>
                      <p class="text-muted mb-4">
                      </p>
                    </div>

                    <hr />
                    <div class="text-center">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="mt-4 mt-sm-0">
                            <h5 class="text-muted mb-2">Primeiramente gostaríamos em desejar boas-vindas à econoCARGO
                              Gestão Colaborativa!</h5>
                            <h5 class="font-size-15">
                              <p>Esse questionário será utilizado como parâmetro para estruturarmos a operação logística
                                de fretes
                                (CIF/FOB) de sua empresa.</p>
                            </h5>
                            <h5>
                              <p>Caso as informações operacionais sejam diferentes por CNPJ ou Origem, favor preencher
                                um formulário
                                para cada um deles. Qualquer dúvida, estamos à disposição.</p>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="mb-3">
                      <label for="commentemail-input">Email</label>
                      <input type="email" class="form-control" id="commentemail-input" placeholder="Enter email" />
                    </div>
                    <hr />
                    <div class="mb-3">
                      <label for="commentemail-input">Para melhor entendimento da operação, descreva detalhadamente qual
                        segmento dos produtos.</label>
                      <input type="email" class="form-control" id="commentemail-input"
                        placeholder="Detalhamento segmento de produtos" />
                    </div>
                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Precisa de licença especial para transporte? <span
                          class="required">*</span></h5>

                      <b-form-group v-slot="{ ariaDescribedby1 }">
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="a">Não</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="b">Portaria 344</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="c">AFE</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="d">AE</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="e">Outro:</b-form-radio>
                        <input v-if="selectedRadioDefault === 'e'" type="text" class="form-control" id="outros-licenca"
                          placeholder="Digite a licença" />
                      </b-form-group>
                    </div>


                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Favor inserir algumas fotos dos produtos para que possamos conhecer
                        a operação. Se possível, sem embalar e também embalados para transporte.</h5>
                      <div class="row">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body">
                              <h4 class="card-title">Anexar arquivos</h4>
                              <p class="card-title-desc">Arraste os arquivos para a linha pontilhada ou clique no botão
                                para selecionar arquivos.</p>
                              <DropZone @drop.prevent="drop" @change="selectedFile" />
                              <span class="file-info">Arquivos selecionados: {{ dropzoneFile.name }}</span>
                              <div class="text-center mt-4">
                                <button type="button" class="btn btn-primary">Anexar arquivos</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Quais CNPJ que serão utilizados como TOMADORES dos fretes? <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-cnpj-tromador"
                        placeholder="Digite os CNPJ's TOMADORES dos fretes" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Qual endereço de coleta? <span class="required">*</span>
                        <p>Se houver mais de um endereço de coleta favor indicar...</p>
                      </h5>
                      <input type="text" class="form-control mt-2" id="outros-endereco-coleta"
                        placeholder="Digite o(s) endereço(s) de coleta" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Qual horário de coleta? Existe alguma restrição? <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-horarios-coleta"
                        placeholder="Digite o(s) horario(s) de coleta e as restrições se houver" />
                    </div>

                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Precisa de licença especial para transporte? <span
                          class="required">*</span></h5>
                      <b-form-group v-slot="{ ariaDescribedby1 }">
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="a">B2B</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="b">B2C</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="c">Ambos</b-form-radio>
                      </b-form-group>
                    </div>

                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">A empresa realiza vendas no modal e-commerce? <span
                          class="required">*</span></h5>

                      <b-form-group v-slot="{ ariaDescribedby1 }">
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="a">Sim</b-form-radio>
                        <b-form-radio v-model="selectedRadioDefault" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="b">Não</b-form-radio>
                      </b-form-group>

                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Em caso afirmativo na pergunta anterior, qual HUB utiliza?</h5>
                      <div class="col-sm-auto">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="vtexCheck" />
                          <label class="form-check-label" for="vtexCheck">VTEX</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">TRAY</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="traycorpCheck" />
                          <label class="form-check-label" for="traycorpCheck">TRAYCORP</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="traycorpCheck" />
                          <label class="form-check-label" for="traycorpCheck">LOJA INTEGRADA</label>
                        </div>
                        <div class="form-check">

                          <input class="form-check-input" type="checkbox" id="nenhumCheck" />
                          <label class="form-check-label" for="nenhumCheck">NENHUM</label>
                        </div>
                        <div class="form-check">

                          <input class="form-check-input" v-model="CheckboxOutrosHubs" type="checkbox" id="outrosHubsCheck" />
                          <label class="form-check-label" for="outrosCheck">OUTROS</label>

                          <input v-if="CheckboxOutrosHubs === true" type="text" class="form-control mt-2"
                            id="outros-hubs" placeholder="Digite o HUB utilizado para venda" />
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Possui canal de venda em algum Marketplaces? <span
                          class="required">*</span></h5>
                      <b-form-group v-slot="{ ariaDescribedby1 }">
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="a">Não</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="b">Madeira Madeira</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="c">Mercado Livre</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="d">Amazon</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="e">Via Varejo</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="f">Magazine Luiza</b-form-radio>
                        <b-form-radio v-model="selectedRadioOutros" :aria-describedby="ariaDescribedby1"
                          name="some-radios1" value="g">Outros</b-form-radio>
                        <input v-if="selectedRadioOutros === 'g'" type="text" class="form-control mt-2"
                          id="outros-canais-venda" placeholder="Digite outros canais de venda" />
                      </b-form-group>
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Haverá integração via API? <span class="required">*</span></h5>
                      <div class="col-sm-auto">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="vtexCheck" />
                          <label class="form-check-label" for="vtexCheck">Loja Web x EconoCargo.</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">ERP x EconoCargo.</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="traycorpCheck" />
                          <label class="form-check-label" for="traycorpCheck">Hub x EconoCargo</label>
                        </div>
                        <div class="form-check">

                          <input class="form-check-input" type="checkbox" id="nenhumCheck" />
                          <label class="form-check-label" for="nenhumCheck">Não</label>
                        </div>
                        <div class="form-check">

                          <input class="form-check-input" v-model="CheckboxOutrasApis" type="checkbox" id="outrasApisCheck" />
                          <label class="form-check-label" for="outrasApiCheck">OUTROS</label>

                          <input v-if="CheckboxOutrasApis == true" type="text" class="form-control mt-2"
                            id="outros-integracoes" placeholder="Digite a licença" />
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Em caso afirmativo na pergunta anterior, descreva um pouco de qual
                        plataforma será ligada a API? <span class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-integracoes-plataforma"
                        placeholder="Digite a plataforma para integração" />
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Quais informações serão necessárias nas integrações? <span
                          class="required">*</span></h5>
                      <div class="col-sm-auto">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="vtexCheck" />
                          <label class="form-check-label" for="vtexCheck">Retorno do Frete/Valor</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">Retorno do Rastreio/Entrega</label>
                        </div>

                        <div class="form-check">

                          <input class="form-check-input" v-model="CheckboxOutrosIntegracoes" type="checkbox" id="outrasIntegracoesCheck" />
                          <label class="form-check-label" for="outrosCheck">OUTROS</label>

                          <input v-if="CheckboxOutrosIntegracoes == true" type="text" class="form-control mt-2"
                            id="outros-integracoes" placeholder="Digite a licença"/>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Qual ticket médio dos embarques? <span class="required">*</span>
                      </h5>
                      <input type="text" class="form-control mt-2" id="outros-ticket" placeholder="Digite a licença" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Qual peso médio dos embarques? <span class="required">*</span>*</h5>
                      <input type="text" class="form-control mt-2" id="outros-peso-embarque"
                        placeholder="Digite a licença" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Qual o valor mensal aproximado gasto com frete? <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-custo-frete"
                        placeholder="Digite a licença" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Quais regiões com maior concentração de venda? <span
                          class="required">*</span></h5>
                      <div class="col-sm-auto">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="vtexCheck" />
                          <label class="form-check-label" for="vtexCheck">Sudeste</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">Sul</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">Centro-Oeste</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">Norte</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" id="trayCheck" />
                          <label class="form-check-label" for="trayCheck">Nordeste</label>
                        </div>

                      </div>
                    </div>

                    <hr />
                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">
                        <p>Tabelas vigentes das transportadoras já ativas na operação. (Favor
                          enviar com todas as informações abaixo)</p>
                        <p>1. CNPJ da Transportadora; </p>
                        <p>2. E-mail da Transportadora (e-mail para solicitações de coleta); </p>
                        <p>3. Tabela atualizada; </p>
                        <p>4. Lista de abrangências e prazos, com classificação. (Em formato Excel); </p>
                        <p>5. Relação de TDA, TDE, TRT e demais taxas que houver cobrança. (Em formato Excel); </p>
                        <p>

                        </p>
                        <p>
                        </p>
                        <p>Obs: Tabela só será inserida em sistema quando todas essas informações forem enviadas. </p>
                        <p> </p>
                        <p> </p>
                      </h5>
                      <h6>
                        <p><span class="required">*Favor enviar em arquivo ZIP por transportadora.</span></p>
                      </h6>
                      <div class="row">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body">
                              <h4 class="card-title">Anexar arquivos</h4>
                              <p class="card-title-desc">Arraste os arquivos para a linha pontilhada ou clique no botão
                                para selecionar arquivos.</p>
                              <DropZone @drop.prevent="drop" @change="selectedFile" />
                              <span class="file-info">Arquivos selecionados: {{ dropzoneFile.name }}</span>
                              <div class="text-center mt-4">
                                <button type="button" class="btn btn-primary">Anexar arquivos</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Responsável Coleta/devolução: Nome, Telefone com DDD e E-mail <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-input" placeholder="Digite a licença" />
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Responsável recebimento de faturas: Nome, Telefone com DDD e E-mail
                        <span class="required">*</span>
                      </h5>
                      <input type="text" class="form-control mt-2" id="outros-input" placeholder="Digite a licença" />
                    </div>

                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Responsável pelo faturamento: Nome, Telefone com DDD e E-mail <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-input" placeholder="Digite a licença" />
                    </div>
                    <hr />

                    <div class="mt-4">
                      <h5 class="font-size-14 mb-4">Responsável pelo TI: Nome, Telefone com DDD e E-mail <span
                          class="required">*</span></h5>
                      <input type="text" class="form-control mt-2" id="outros-input" placeholder="Digite a licença" />
                    </div>

                    <div class="text-center mt-4">
                      <button type="button" class="btn btn-primary">Salvar formulário</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>